export default __webpack_public_path__ + "static/logo-663da9202be69963ccc83d7c0ef70a12.png";